import { render, staticRenderFns } from "./RichModal.vue?vue&type=template&id=610b7246&scoped=true&"
import script from "./RichModal.vue?vue&type=script&lang=ts&"
export * from "./RichModal.vue?vue&type=script&lang=ts&"
import style0 from "./RichModal.vue?vue&type=style&index=0&id=610b7246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610b7246",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
